"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeIsBetween = exports.timeIsBeforeOrEqual = exports.timeIsBefore = exports.timeIsAfterOrEqual = exports.timeIsAfter = exports.timeDiffInWeeks = exports.timeDiffInMinutes = exports.timeDiffInDays = exports.substractHours = exports.roundUpDateTime = exports.roundToQuarter = exports.printWeekdayAndDate = exports.printTime = exports.printLongDate = exports.printInputTime = exports.printInputDateTime = exports.printInputDate = exports.printDateTime = exports.printDate = exports.periodToDays = exports.parseDateWithoutZ = exports.parseDate = exports.momentToInteger = exports.momentToDate = exports.momentGetDayNumber = exports.mergeDateTime = exports.isValidDateTimeString = exports.isToday = exports.isSameTime = exports.isSameDay = exports.getWeekDayName = exports.getWeekDay = exports.getTzOffset = exports.getStartOfMonth = exports.getRoundedDate = exports.getMinDate = exports.getMaxDate = exports.getEndOfMonth = exports.getDatesArray = exports.dateToMoment = exports.dateIsBetween = exports.dateIsBeforeOrEqual = exports.dateIsBefore = exports.dateIsAfterOrEqual = exports.dateIsAfter = exports.addWeeks = exports.addMonths = exports.addMinutes = exports.addHours = exports.addDays = exports.PRINT_WEEKDAY_AND_DATE_FORMAT = exports.PRINT_TIME_FORMAT = exports.PRINT_LONG_DATE_FORMAT = exports.PRINT_DATE_TIME_FORMAT_SECONDS = exports.PRINT_DATE_TIME_FORMAT = exports.PRINT_DATE_FORMAT = exports.INPUT_TIME_FORMAT_MINUTES = exports.INPUT_TIME_FORMAT_HOURS = exports.INPUT_TIME_FORMAT = exports.INPUT_DATE_TIME_CLIENT_FORMAT_SECONDS = exports.INPUT_DATE_TIME_CLIENT_FORMAT = exports.INPUT_DATE_FORMAT = void 0;
var _dateFns = require("date-fns");
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _it = _interopRequireDefault(require("date-fns/locale/it"));
var _pt = _interopRequireDefault(require("date-fns/locale/pt"));
var _dateFnsTz = require("date-fns-tz");
var LONG_DATE_LOCALES = {
  it: _it["default"],
  pt: _pt["default"],
  en: _enUS["default"]
};
var PRINT_DATE_TIME_FORMAT = exports.PRINT_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
var PRINT_DATE_TIME_FORMAT_SECONDS = exports.PRINT_DATE_TIME_FORMAT_SECONDS = 'dd/MM/yyyy HH:mm:ss';
var PRINT_DATE_FORMAT = exports.PRINT_DATE_FORMAT = 'dd/MM/yyyy';
var PRINT_TIME_FORMAT = exports.PRINT_TIME_FORMAT = 'HH:mm';
var PRINT_WEEKDAY_AND_DATE_FORMAT = exports.PRINT_WEEKDAY_AND_DATE_FORMAT = 'EEE: MMM d yyyy';
var INPUT_DATE_FORMAT = exports.INPUT_DATE_FORMAT = 'yyyy-MM-dd';
var INPUT_TIME_FORMAT = exports.INPUT_TIME_FORMAT = 'HH:mm:ss';
var INPUT_TIME_FORMAT_HOURS = exports.INPUT_TIME_FORMAT_HOURS = 'HH';
var INPUT_TIME_FORMAT_MINUTES = exports.INPUT_TIME_FORMAT_MINUTES = 'mm';
var INPUT_DATE_TIME_CLIENT_FORMAT = exports.INPUT_DATE_TIME_CLIENT_FORMAT = 'yyyy-MM-dd HH:mm';
var INPUT_DATE_TIME_CLIENT_FORMAT_SECONDS = exports.INPUT_DATE_TIME_CLIENT_FORMAT_SECONDS = "yyyy-MM-dd'T'HH:mm:ss";
var isValidDateTimeString = exports.isValidDateTimeString = function isValidDateTimeString(val) {
  if (!val || typeof val !== 'string') {
    return false;
  }
  var reg = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/gm;
  return reg.test(val);
};
var parseDate = exports.parseDate = function parseDate(str) {
  var returnNowIfNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!str) {
    return returnNowIfNull ? new Date() : str;
  }
  if (typeof str === 'number') {
    return new Date(str);
  }
  if (str instanceof Date) {
    return str;
  }
  if (typeof str === 'string') {
    if (!str.endsWith('Z')) {
      str = str + 'Z';
    }
  }
  var result = (0, _dateFns.parseISO)(str);
  return !isNaN(result.getTime()) ? result : new Date(str);
};
var parseDateWithoutZ = exports.parseDateWithoutZ = function parseDateWithoutZ(str) {
  var returnNowIfNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!str) {
    return returnNowIfNull ? new Date() : str;
  }
  if (typeof str === 'number') {
    return new Date(str);
  }
  if (str instanceof Date) {
    return str;
  }
  var result = (0, _dateFns.parseISO)(str);
  return !isNaN(result.getTime()) ? result : new Date(str);
};
var printTime = exports.printTime = function printTime(str) {
  var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!str) {
    return str;
  }
  try {
    var date = z ? parseDate(str) : parseDateWithoutZ(str);
    var finalDate = utc ? (0, _dateFnsTz.utcToZonedTime)(date, 'UTC') : date;
    return (0, _dateFns.format)(finalDate, PRINT_TIME_FORMAT);
  } catch (_unused) {
    return str;
  }
};
var printInputTime = exports.printInputTime = function printInputTime(str) {
  var z = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!str) {
    return str;
  }
  if (typeof str === 'number') {
    return new Date(str).toISOString().slice(11, 19);
  }
  try {
    var date = z ? parseDate(str) : parseDateWithoutZ(str);
    return (0, _dateFns.format)((0, _dateFnsTz.utcToZonedTime)(date, 'UTC'), INPUT_TIME_FORMAT);
  } catch (_unused2) {
    return str;
  }
};
var printDate = exports.printDate = function printDate(str) {
  var z = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!str) {
    return str;
  }
  try {
    return (0, _dateFns.format)(z ? parseDate(str) : parseDateWithoutZ(str), PRINT_DATE_FORMAT);
  } catch (_unused3) {
    return str;
  }
};
var printInputDate = exports.printInputDate = function printInputDate(str) {
  var z = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!str) {
    return '';
  }
  try {
    return (0, _dateFns.format)(z ? parseDate(str) : parseDateWithoutZ(str), INPUT_DATE_FORMAT);
  } catch (_unused4) {
    return '';
  }
};
var PRINT_LONG_DATE_FORMAT = exports.PRINT_LONG_DATE_FORMAT = 'EEEE, d MMMM yyyy';

// Locale-aware long date, e.g. "lunedì, 5 giugno 2026" / "Monday, 5 June 2026".
// localeCode is an i18n language tag ("it", "en", "en-US", "pt", …); falls back to Italian.
var printLongDate = exports.printLongDate = function printLongDate(str) {
  var localeCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'it';
  var utc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!str) {
    return str;
  }
  try {
    var date = z ? parseDate(str) : parseDateWithoutZ(str);
    var finalDate = utc ? (0, _dateFnsTz.utcToZonedTime)(date, 'UTC') : date;
    var locale = LONG_DATE_LOCALES[(localeCode || '').slice(0, 2)] || _it["default"];
    return (0, _dateFns.format)(finalDate, PRINT_LONG_DATE_FORMAT, {
      locale: locale
    });
  } catch (_unused5) {
    return str;
  }
};
var printDateTime = exports.printDateTime = function printDateTime(str) {
  var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!str) {
    return str;
  }
  try {
    var date = z ? parseDate(str) : parseDateWithoutZ(str);
    var finalDate = utc ? (0, _dateFnsTz.utcToZonedTime)(date, 'UTC') : date;
    var fmt = seconds ? PRINT_DATE_TIME_FORMAT_SECONDS : PRINT_DATE_TIME_FORMAT;
    return (0, _dateFns.format)(finalDate, fmt);
  } catch (_unused6) {
    return str;
  }
};
var printInputDateTime = exports.printInputDateTime = function printInputDateTime(str) {
  var utc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var T = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!str) {
    return str;
  }
  try {
    var date = z ? parseDate(str) : parseDateWithoutZ(str);
    var finalDate = utc ? (0, _dateFnsTz.utcToZonedTime)(date, 'UTC') : date;
    var fmt = T ? INPUT_DATE_TIME_CLIENT_FORMAT_SECONDS : INPUT_DATE_TIME_CLIENT_FORMAT;
    return (0, _dateFns.format)(finalDate, fmt);
  } catch (_unused7) {
    return str;
  }
};
var printWeekdayAndDate = exports.printWeekdayAndDate = function printWeekdayAndDate(str) {
  if (!str) {
    return str;
  }
  try {
    return (0, _dateFns.format)(parseDate(str), PRINT_WEEKDAY_AND_DATE_FORMAT);
  } catch (_unused8) {
    return str;
  }
};
var dateIsBefore = exports.dateIsBefore = function dateIsBefore(x, y) {
  var compareOnlyDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!x) {
    return false;
  }
  // moment-era semantics: a missing second argument means "compare against now"
  var dateX = parseDate(x);
  var dateY = parseDate(y);
  if (compareOnlyDate) {
    return (0, _dateFns.isBefore)(parseDate((0, _dateFns.format)(dateX, INPUT_DATE_FORMAT)), parseDate((0, _dateFns.format)(dateY, INPUT_DATE_FORMAT)));
  }
  return (0, _dateFns.isBefore)(dateX, dateY);
};
var dateIsBeforeOrEqual = exports.dateIsBeforeOrEqual = function dateIsBeforeOrEqual(x, y) {
  var compareOnlyDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var valuesAreDates = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!x || !y) {
    return false;
  }
  var dateX = parseDate(x);
  var dateY = parseDate(y);
  if (valuesAreDates && compareOnlyDate) {
    return (0, _dateFns.isBefore)(dateX, dateY) || (0, _dateFns.isSameDay)(dateX, dateY);
  }
  if (compareOnlyDate) {
    var dX = parseDate((0, _dateFns.format)(dateX, INPUT_DATE_FORMAT));
    var dY = parseDate((0, _dateFns.format)(dateY, INPUT_DATE_FORMAT));
    return (0, _dateFns.isBefore)(dX, dY) || dX.getTime() === dY.getTime();
  }
  return (0, _dateFns.isBefore)(dateX, dateY) || dateX.getTime() === dateY.getTime();
};
var dateIsAfter = exports.dateIsAfter = function dateIsAfter(x, y) {
  var compareOnlyDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!x) {
    return false;
  }
  // moment-era semantics: a missing second argument means "compare against now"
  var dateX = z ? parseDate(x, true) : parseDateWithoutZ(x);
  var dateY = y ? z ? parseDate(y, true) : parseDateWithoutZ(y) : new Date();
  if (compareOnlyDate) {
    return (0, _dateFns.isAfter)(dateX, dateY) && !(0, _dateFns.isSameDay)(dateX, dateY);
  }
  return (0, _dateFns.isAfter)(dateX, dateY);
};
var dateIsAfterOrEqual = exports.dateIsAfterOrEqual = function dateIsAfterOrEqual(x, y) {
  var compareOnlyDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var valuesAreDates = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!x) {
    return false;
  }
  var dateX = parseDate(x);
  var dateY = parseDate(y);
  if (valuesAreDates && compareOnlyDate) {
    return (0, _dateFns.isAfter)(dateX, dateY) || (0, _dateFns.isSameDay)(dateX, dateY);
  }
  if (compareOnlyDate) {
    var dX = parseDate((0, _dateFns.format)(dateX, INPUT_DATE_FORMAT));
    var dY = parseDate((0, _dateFns.format)(dateY, INPUT_DATE_FORMAT));
    return (0, _dateFns.isAfter)(dX, dY) || dX.getTime() === dY.getTime();
  }
  return (0, _dateFns.isAfter)(dateX, dateY) || dateX.getTime() === dateY.getTime();
};
var timeIsBefore = exports.timeIsBefore = function timeIsBefore(x, y) {
  var compareOnlyTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!x || !y) {
    return false;
  }
  var dateX = compareOnlyTime ? parseDate(printTime(x)) : parseDate(x);
  var dateY = compareOnlyTime ? parseDate(printTime(y)) : parseDate(y);
  return (0, _dateFns.isBefore)(dateX, dateY);
};
var timeIsBeforeOrEqual = exports.timeIsBeforeOrEqual = function timeIsBeforeOrEqual(x, y) {
  var compareOnlyTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!x || !y) {
    return false;
  }
  var dateX = compareOnlyTime ? parseDate(printTime(x)) : parseDate(x);
  var dateY = compareOnlyTime ? parseDate(printTime(y)) : parseDate(y);
  return (0, _dateFns.isBefore)(dateX, dateY) || (0, _dateFns.isEqual)(dateX, dateY);
};
var timeIsAfter = exports.timeIsAfter = function timeIsAfter(x, y) {
  var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!x || !y) {
    return false;
  }
  var timeX = z ? parseDate(printTime(x), true) : parseDateWithoutZ(x);
  var timeY = z ? parseDate(printTime(y), true) : parseDateWithoutZ(y);
  return (0, _dateFns.isAfter)(timeX, timeY);
};
var timeIsAfterOrEqual = exports.timeIsAfterOrEqual = function timeIsAfterOrEqual(x, y) {
  if (!x || !y) {
    return false;
  }
  var timeX = parseDate(printTime(x));
  var timeY = parseDate(printTime(y));
  return (0, _dateFns.isAfter)(timeX, timeY) || timeX.getTime() === timeY.getTime();
};
var dateIsBetween = exports.dateIsBetween = function dateIsBetween(input, x, y) {
  var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var date = z ? parseDate(input, true) : parseDateWithoutZ(input);
  var start = z ? parseDate(x, true) : parseDateWithoutZ(x);
  var end = z ? parseDate(y, true) : parseDateWithoutZ(y);
  if (!date || !start || !end) {
    return false;
  }
  var interval = start <= end ? {
    start: start,
    end: end
  } : {
    start: end,
    end: start
  };
  return (0, _dateFns.isSameDay)(date, start) || (0, _dateFns.isSameDay)(date, end) || (0, _dateFns.isWithinInterval)(date, interval);
};
var REF_DATE = new Date('2000-01-01T00:00:00Z');
var timeIsBetween = exports.timeIsBetween = function timeIsBetween(input, min, max) {
  if (!input || !min || !max) {
    return false;
  }
  var date = (0, _dateFns.parse)(printInputTime(input), INPUT_TIME_FORMAT, REF_DATE);
  var start = (0, _dateFns.parse)(printInputTime(min), INPUT_TIME_FORMAT, REF_DATE);
  var end = (0, _dateFns.parse)(printInputTime(max), INPUT_TIME_FORMAT, REF_DATE);
  if (!(0, _dateFns.isValid)(date) || !(0, _dateFns.isValid)(start) || !(0, _dateFns.isValid)(end)) {
    return false;
  }
  if (start <= end) {
    return (0, _dateFns.isWithinInterval)(date, {
      start: start,
      end: end
    });
  }
  return (0, _dateFns.isWithinInterval)(date, {
    start: start,
    end: new Date('9999-12-31T23:59:59Z')
  }) || (0, _dateFns.isWithinInterval)(date, {
    start: new Date('0000-01-01T00:00:00Z'),
    end: end
  });
};
var isToday = exports.isToday = function isToday(input) {
  return input ? (0, _dateFns.isSameDay)((0, _dateFnsTz.utcToZonedTime)(parseDate(input), 'UTC'), (0, _dateFnsTz.utcToZonedTime)(new Date(), 'UTC')) : false;
};
var addMinutes = exports.addMinutes = function addMinutes(val, minutes) {
  return val && minutes ? new Date(parseDate(val).getTime() + minutes * 60 * 1000) : val;
};
var addHours = exports.addHours = function addHours(val, hours) {
  return val && hours ? new Date(parseDate(val).getTime() + hours * 60 * 60 * 1000) : val;
};
var substractHours = exports.substractHours = function substractHours(val, hours) {
  return val && hours != null ? new Date(parseDate(val).getTime() - hours * 60 * 60 * 1000) : val;
};
var addDays = exports.addDays = function addDays(val, days) {
  if (!val || days == null) {
    return val;
  }
  var d = parseDate(val);
  var result = new Date(d);
  result.setDate(result.getDate() + days);
  return result;
};
var addWeeks = exports.addWeeks = function addWeeks(val, weeks) {
  return val && weeks ? (0, _dateFns.addWeeks)(parseDate(val), weeks) : val;
};
var addMonths = exports.addMonths = function addMonths(val, months) {
  return val && months ? (0, _dateFns.addMonths)(parseDate(val), months) : val;
};
var momentToDate = exports.momentToDate = function momentToDate(str) {
  var date = parseDate(str);
  var isoString = date.toISOString().split('.')[0];
  return new Date(isoString);
};
var dateToMoment = exports.dateToMoment = function dateToMoment(date) {
  return date;
};
var timeDiffInMinutes = exports.timeDiffInMinutes = function timeDiffInMinutes(start, end) {
  return (0, _dateFns.differenceInMinutes)(parseDate(end), parseDate(start));
};
var timeDiffInDays = exports.timeDiffInDays = function timeDiffInDays(start, end) {
  return (0, _dateFns.differenceInDays)(parseDate(end), parseDate(start));
};
var timeDiffInWeeks = exports.timeDiffInWeeks = function timeDiffInWeeks(start, end) {
  return (0, _dateFns.differenceInWeeks)(parseDate(end), parseDate(start));
};
var getMinDate = exports.getMinDate = function getMinDate(start, end) {
  return !start || !end ? start || end : (0, _dateFns.min)([parseDate(start), parseDate(end)]);
};
var getMaxDate = exports.getMaxDate = function getMaxDate(start, end) {
  return !start || !end ? start || end : (0, _dateFns.max)([parseDate(start), parseDate(end)]);
};
var mergeDateTime = exports.mergeDateTime = function mergeDateTime(date, time) {
  var utc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dateStr = printInputDate(date);
  var timeStr = printInputTime(time);
  if (!dateStr || !timeStr) return null;
  var merged = parseDate("".concat(dateStr, "T").concat(timeStr));
  return utc ? (0, _dateFnsTz.utcToZonedTime)(merged, 'UTC') : merged;
};
var isSameDay = exports.isSameDay = function isSameDay(x, y) {
  return x && y ? (0, _dateFns.isSameDay)((0, _dateFnsTz.utcToZonedTime)(parseDate(x), 'UTC'), (0, _dateFnsTz.utcToZonedTime)(parseDate(y), 'UTC')) : false;
};
var isSameTime = exports.isSameTime = function isSameTime(a, b) {
  return printInputTime(a) === printInputTime(b);
};
var getRoundedDate = exports.getRoundedDate = function getRoundedDate() {
  var minutes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var date = d ? new Date(d) : new Date(Date.now() + 5 * 60 * 1000);
  var ms = 1000 * 60 * minutes;
  return new Date(Math.round(date.getTime() / ms) * ms);
};
var getWeekDay = exports.getWeekDay = function getWeekDay(val) {
  return (0, _dateFns.getDay)((0, _dateFnsTz.utcToZonedTime)(parseDate(val), 'UTC'));
};
var getWeekDayName = exports.getWeekDayName = function getWeekDayName(val) {
  return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][(0, _dateFns.getDay)((0, _dateFnsTz.utcToZonedTime)(parseDate(val), 'UTC'))];
};
var roundToQuarter = exports.roundToQuarter = function roundToQuarter(val, returnNowIfNull) {
  var date = parseDate(val, returnNowIfNull);
  var utcDate = (0, _dateFnsTz.utcToZonedTime)(date, 'UTC');
  var minutes = utcDate.getMinutes();
  var hours = utcDate.getHours();
  var minute = ((minutes + 7.5) / 15 | 0) * 15 % 60;
  var hour = ((minutes / 105 + 0.5 | 0) + hours) % 24;
  return (0, _dateFns.set)(utcDate, {
    hours: hour,
    minutes: minute,
    seconds: 0,
    milliseconds: 0
  });
};
var getStartOfMonth = exports.getStartOfMonth = function getStartOfMonth(val) {
  return (0, _dateFns.startOfMonth)(parseDate(val));
};
var getEndOfMonth = exports.getEndOfMonth = function getEndOfMonth(val) {
  return (0, _dateFns.endOfMonth)(parseDate(val));
};
var momentToInteger = exports.momentToInteger = function momentToInteger(m) {
  return +parseDate(m);
};
var momentGetDayNumber = exports.momentGetDayNumber = function momentGetDayNumber(m) {
  return (0, _dateFns.getDay)(parseDate(m));
};
var roundUpDateTime = exports.roundUpDateTime = function roundUpDateTime(input) {
  var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (!input) {
    return input;
  }
  var date = typeof input === 'number' ? new Date(input) : parseDate(input);
  var coefficient = 1000 * 60 * minutes;
  return new Date(Math.ceil(date.getTime() / coefficient) * coefficient);
};
var getDatesArray = exports.getDatesArray = function getDatesArray(start, end) {
  return (0, _dateFns.eachDayOfInterval)({
    start: parseDate(start),
    end: parseDate(end)
  });
};
var periodToDays = exports.periodToDays = function periodToDays(duration, durationType) {
  if (durationType === 'weeks') {
    return +duration * 7;
  }
  if (durationType === 'months') {
    return +duration * 30;
  }
  return +duration;
};
var getTzOffset = exports.getTzOffset = function getTzOffset(pt, ct, setHoursDifference) {
  var getHoursDifference = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var now = new Date();
  var t1Offset = (0, _dateFnsTz.getTimezoneOffset)(pt, now);
  var t2Offset = (0, _dateFnsTz.getTimezoneOffset)(ct, now);
  var differenceInHours = (t1Offset - t2Offset) / (1000 * 60 * 60);
  if (getHoursDifference) {
    return differenceInHours;
  }
  if (setHoursDifference) {
    setHoursDifference(differenceInHours);
  }
  if (differenceInHours > 0) {
    return "".concat(pt, " is ").concat(differenceInHours, " hour(s) ahead of ").concat(ct);
  }
  if (differenceInHours < 0) {
    return "".concat(pt, " is ").concat(Math.abs(differenceInHours), " hour(s) behind ").concat(ct);
  }
  return "".concat(pt, " and ").concat(ct, " are in the same time zone");
};
